import React from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  IconButton,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { Close, CloudUpload } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";

export default function PostJobDetail({ open, handleClose, setCv, cv, job }) {
  const handleApply = () => {
    if (!cv) {
      enqueueSnackbar("Please attach your CV before applying!", {
        variant: "error",
      });
      return;
    }
    enqueueSnackbar("Application submitted successfully!", {
      variant: "success",
    });
    handleClose();
    setCv(null);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "600px",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 3,
          p: 2,
          outline: "none",
          overflowY: "auto", // Enables scrolling if content exceeds modal height
          maxHeight: "95vh", // Ensures modal doesn't overflow vertically
          "&::-webkit-scrollbar": {
            width: "8px", // Decrease width
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888", // Scrollbar color
            borderRadius: "5px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555", // Hover effect
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="h6" fontWeight="bold">
            Job Detail
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>

        <Grid container spacing={2}>
          {[
            { label: "Job Title", key: "title" },
            {
              label: "Job Type",
              key: "type",
              format: (value) => `${value} (Onsite)`,
            },
            { label: "Experience", key: "experience" },
            { label: "Education", key: "education", defaultValue: "Masters" },
            {
              label: "Frequently Salary",
              key: "",
              defaultValue: "Monthly",
            },
            { label: "Min Salary", key: "minSalary", defaultValue: " €300/m" },
            { label: "Max Salary", key: "", defaultValue: "€500/m" },
          ].map(({ label, key, defaultValue, format }, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card
                sx={{
                  p: 1,
                  border: "1px solid silver",
                  boxShadow: "none",
                  borderRadius: "5px",
                }}
              >
                <CardContent sx={{ padding: "4px !important" }}>
                  <Typography sx={{ fontSize: "13px" }}>
                    <strong>{label}:</strong>{" "}
                    {format
                      ? format(job?.[key] || defaultValue || "N/A")
                      : job?.[key] || defaultValue || "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Card
              sx={{
                p: 1,
                border: "1px solid silver",
                boxShadow: "none",
                borderRadius: "5px",
              }}
            >
              <CardContent sx={{ padding: "5px !important" }}>
                <Typography sx={{ fontSize: "13px" }}>
                  <strong>Location:</strong> {job?.location || "N/A"}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Card
          sx={{
            p: 1,
            mt: 2,
            border: "1px solid silver",
            boxShadow: "none",
            borderRadius: "5px",
          }}
        >
          <CardContent sx={{ padding: "5px !important" }}>
            <Typography
              sx={{ fontSize: "14px" }}
              variant="h6"
              fontWeight="bold"
            >
              Job Description
            </Typography>
            <Typography sx={{ fontSize: "13px" }}>
              {job?.description ||
                "This is a an role with leadership responsibilities."}
            </Typography>
          </CardContent>
        </Card>

        <Card
          sx={{
            p: 1,
            mt: 2,
            border: "1px solid silver",
            boxShadow: "none",
            borderRadius: "5px",
          }}
        >
          <CardContent sx={{ padding: "5px !important" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                className="cv-upload"
                variant="contained"
                component="label"
                startIcon={<CloudUpload />}
              >
                Upload CV
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  hidden
                  onChange={(e) => setCv(e.target.files[0])}
                />
              </Button>
              {cv && (
                <Box
                  sx={{
                    position: "relative",
                    border: "1px solid silver",
                    borderRadius: "5px",
                    p: 1,
                    ml: 2,
                    marginTop: "1px !important",
                  }}
                >
                  <IconButton
                    className="cross-icon-btn"
                    size="small"
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      right: "-5px",
                      backgroundColor: "red",
                      color: "white",
                      padding: "1px",
                      fontSize: "10px !important",
                    }}
                    onClick={() => setCv(null)}
                  >
                    <CloseIcon
                      sx={{ fontSize: "15px !important" }}
                      fontSize="small"
                    />
                  </IconButton>
                  <Typography sx={{ fontSize: "13px" }}>{cv.name}</Typography>
                </Box>
              )}
            </div>
            <Typography mt={1} variant="body2" color="textSecondary">
              Accepted file types: .pdf, .doc, .docx
            </Typography>
          </CardContent>
        </Card>

        <Button
          className="mui-btn"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ bgcolor: "#000080", color: "white", mt: 2 }}
          onClick={handleApply}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
}
